import { useEffect, useState } from 'react'
import { safeLocalStorage, safeSessionStorage } from 'ui'

const useBrowserStorageCheck = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const closeModal = () => setIsModalOpen(false)

  useEffect(() => {
    if (!safeLocalStorage.isStorageAvailable() || !safeSessionStorage.isStorageAvailable()) {
      setIsModalOpen(true)
    }
  }, [])

  return { isModalOpen, closeModal }
}
export default useBrowserStorageCheck
